export class NotifyPartyInfo{
    notifyPartyId: number;
    NotifyPartyName: string;

    constructor(notifyPartyId: number,NotifyPartyName: string ) {
        this.notifyPartyId=notifyPartyId;
        this.NotifyPartyName=NotifyPartyName;
    }
}